// Machine-translated — pending native review.
const ja: Record<string, string> = {
  // ── App ──────────────────────────────────────────────────────────────────
  'app.title': 'XTM Express',

  // ── Login ────────────────────────────────────────────────────────────────
  'login.title': 'XTM Express',
  'login.subtitle': 'エンタープライズ AI 翻訳ポータル',
  'login.description': '企業の認証情報でサインインして、ドキュメントの翻訳を開始します',
  'login.ssoButton': 'SSO でサインイン',
  'login.footer': 'Zitadel によるセキュリティ保護 · OAuth 2.1',

  // ── Header ───────────────────────────────────────────────────────────────
  'header.title': 'XTM Express',
  'header.avatarLabel': 'ユーザーメニュー',
  'header.languageLabel': '言語を選択',

  // ── Stepper ──────────────────────────────────────────────────────────────
  'stepper.upload': 'アップロード',
  'stepper.analyze': '分析',
  'stepper.translate': '翻訳',

  // ── Upload Page ──────────────────────────────────────────────────────────
  'upload.title': 'コンテンツをアップロード',
  'upload.tab.file': 'ファイルをアップロード',
  'upload.tab.text': 'テキストを入力',
  'upload.text.placeholder': '翻訳するテキストを貼り付けるか入力してください…',
  'upload.text.charCount': '{count} / {max} 文字',
  'upload.text.tooLong': 'テキストが {max} 文字の上限を超えています。短くしてください。',
  'upload.dropzone.title': 'ここにファイルをドロップ',
  'upload.dropzone.or': 'または',
  'upload.dropzone.browse': 'ファイルを参照',
  'upload.dropzone.formats': '{formats} に対応 · 最大 5 ファイル · 1 ファイルあたり 10 MB',
  'upload.sourceLanguage': 'ソース言語',
  'upload.sourceLanguage.placeholder': 'ソース言語を選択...',
  'upload.targetLanguages': 'ターゲット言語',
  'upload.targetLanguages.placeholder': 'ターゲット言語を検索して選択...',
  'upload.targetLanguages.selected': '{count} 言語を選択中',
  'languagePicker.loading': '言語を読み込み中…',
  'languagePicker.loadError': '言語の一覧を読み込めませんでした。',
  'languagePicker.retry': '再試行',
  'languagePicker.noMatch': '「{query}」に一致する言語またはバリアントはありません。',
  'languagePicker.regionalVariants': '地域バリアント',
  'languagePicker.showMore': '{language} のバリアントをさらに {count} 件表示',
  'languagePicker.default': '既定',
  'languagePicker.variantCount': '{count} バリアント',
  'languagePicker.languageOption': '{language}、{count} バリアント、{selected} 件選択',
  'languagePicker.showVariants': '{language} のバリアントを表示',
  'languagePicker.hideVariants': '{language} のバリアントを隠す',
  'languagePicker.remove': '{name} を削除',
  'languagePicker.changeVariant': '{language} のバリアントを変更',
  'languagePicker.changeVariantOf': '{name} のバリアントを変更',
  'languagePicker.searchVariants': '{count} 件のバリアントを検索…',
  'languagePicker.searchVariantsOf': '{language} のバリアントを検索',
  'languagePicker.noVariantMatch': '一致するバリアントはありません。',
  'languagePicker.allVariants': 'すべてのバリアント',
  'languagePicker.added': '追加済み',
  'languagePicker.keys.move': '移動',
  'languagePicker.keys.toggle': '選択 / 選択解除',
  'languagePicker.keys.expand': 'バリアントを表示',
  'languagePicker.keys.collapse': 'バリアントを隠す',
  'languagePicker.keys.clear': '検索をクリア',
  'upload.files.summary': '{count} ファイルをアップロード済み · {size}',
  'upload.files.column.name': 'ファイル',
  'upload.files.column.size': 'サイズ',
  'upload.files.column.actions': '',
  'upload.files.remove': 'ファイルを削除',
  'upload.files.addMore': 'ファイルを追加',
  'upload.analyzeButton': 'コンテンツを分析',
  'upload.maxFiles': 'アップロードできるファイルは最大 5 つです。一部のファイルは追加されませんでした。',
  'upload.error.unsupportedType': '「{name}」は対応していない形式のため、追加されませんでした。対応形式：{formats}',
  'upload.error.zipTooMany': '「{name}」には {count} 個のファイルが含まれています。zip には最大 5 個のファイルを含めることができます。',
  'upload.uploading': 'ファイルをアップロード中...',
  'upload.error': 'アップロードに失敗しました。もう一度お試しください。',
  'upload.error.tooLarge': 'ファイル「{name}」はアップロード上限の {max} を超えています。より小さいファイルを選択してください。',

  // ── Analysis Page ────────────────────────────────────────────────────────
  'analysis.title': 'AI リスク分析',
  'analysis.subtitle': 'AI エンジンが各ファイルの翻訳の複雑さと規制リスクを評価しました。各ファイルの推奨レーンを確認し、承認するか、もう一方のレーンを選択してください。',
  'analysis.risk.high': '高リスク',
  'analysis.risk.low': '低リスク',
  'analysis.risk.high.tooltip': '翻訳ミスが実際のリスクとなる、機密性が高い・複雑・ビジネス上重要なコンテンツ。プロの人間レビュアーに回されます。',
  'analysis.risk.low.tooltip': 'AI エンジンが単独で確実に翻訳できる平易なコンテンツ。即座に翻訳され、ダウンロードできます。',
  'analysis.risk.borderline': '境界付近',
  'analysis.risk.failed': '分析失敗',
  'analysis.risk.failed.tooltip': 'このファイルの AI リスク分析に失敗したため、リスクレベルは判定されていません。フェイルセーフとして、プロの言語専門家が対応するヒューマン・イン・ザ・センターを推奨します。',
  'analysis.risk.failed.message': 'リスク分析に失敗しました — フェイルセーフとしてヒューマン・イン・ザ・センターを推奨します。',
  'analysis.failedBanner': '{count, plural, one {# 件のファイル} other {# 件のファイル}}のリスク分析に失敗しました。LLM 接続が正しいか確認してから、ファイルを再アップロードするかテキストを入力し直してください。',
  'analysis.risk.failed.message.timedOut': 'リスク分析が {minutes, plural, one {# 分} other {# 分}}以内に完了しなかったため、リスクレベルは判定されていません。フェイルセーフとしてヒューマン・イン・ザ・センターを推奨します。',
  'analysis.risk.failed.message.timedOutNoLimit': 'リスク分析が時間内に完了しなかったため、リスクレベルは判定されていません。フェイルセーフとしてヒューマン・イン・ザ・センターを推奨します。',
  'analysis.risk.failed.message.assessmentFailed': 'リスク分析サービスがこのファイルを評価できなかったため、リスクレベルは判定されていません。フェイルセーフとしてヒューマン・イン・ザ・センターを推奨します。',
  'analysis.risk.failed.message.noLlmConnector': '組織に LLM 接続が設定されていないため、このファイルは評価されていません。フェイルセーフとしてヒューマン・イン・ザ・センターを推奨します。',
  'analysis.failedBanner.timedOut': '{count, plural, one {# 件のファイル} other {# 件のファイル}}のリスク分析が時間内に完了しませんでした。フェイルセーフとしてヒューマン・イン・ザ・センターを推奨します。AI-Direct を選ぶこともできます。',
  'analysis.unreadable.badge': 'ファイルを読み取れません',
  'analysis.unreadable.message': '<b>XTM Go はこのファイルを解析できませんでした</b>。評価されていないため、翻訳できません。',
  'analysis.unreadable.remove': 'バッチから削除',
  'analysis.unreadable.remove.aria': '{filename} をバッチから削除',
  'analysis.unreadable.removed': 'バッチから削除済み。翻訳されません。',
  'analysis.unreadable.undo': '元に戻す',
  'analysis.unreadable.undo.aria': '{filename} の削除を元に戻す',
  'analysis.unreadable.banner.single': '<b>このファイルを読み取れなかったため、翻訳できません。</b>ファイルを修正して、新しい翻訳を開始してください。',
  'analysis.unreadable.banner.all': '<b>{count} 件のファイルをどれも読み取れなかったため、翻訳できるものがありません。</b>ファイルを修正して、新しい翻訳を開始してください。',
  'analysis.unreadable.banner.some': '<b>{count} 件のファイルを読み取れなかったため、このバッチはまだ翻訳できません。</b>バッチから {count} 件のファイルを削除すると、残りの {others} 件のファイルを翻訳できます。',
  'analysis.translateButton.removeFailed': '失敗した {count} 件のファイルを削除して翻訳',
  'analysis.announce.removeFirst': '翻訳する前に、読み取れなかった {count} 件のファイルを削除してください。',
  'analysis.announce.removed': '{filename} をバッチから削除しました。翻訳されません。',
  'analysis.announce.restored': '{filename} がバッチに戻りました。含まれている間はバッチを翻訳できません。',
  'analysis.route.aiDirect': 'AI-Direct',
  'analysis.route.xtmCloud': 'ヒューマン・イン・ザ・センター',
  'analysis.route.aiDirect.tooltip': 'AI が瞬時に翻訳し、数分でダウンロードできます。低リスクのコンテンツに推奨されます。',
  'analysis.route.xtmCloud.tooltip': '納品前に専門の人間レビュアーが確認します。高リスクまたは複雑なコンテンツに推奨されます。',
  'analysis.translateButton': '翻訳',
  'analysis.translateButton.files': '{count} 件のファイルを翻訳',
  'analysis.translateButton.decideMore': '翻訳するには、あと {count} 件決定してください',
  'analysis.translateButton.decideSingle': '翻訳するには、レーンを承認または変更してください',
  'analysis.risk.borderline.hint': '<b>境界付近:</b> スコアが低リスクと高リスクの境界に近いため、推奨は逆になっていた可能性があります。このファイルは慎重に確認してください。',
  'analysis.suggestion.label': 'AI の推奨',
  'analysis.suggestion.labelFailSafe': 'フェイルセーフの推奨',
  'analysis.decision.accept': '推奨を承認',
  'analysis.decision.accept.aria': '{filename} の推奨を承認',
  'analysis.decision.useOther': '代わりに {lane} を使用',
  'analysis.decision.useOther.aria': '{filename} に代わりに {lane} を使用',
  'analysis.decision.accepted': '承認済み: <b>{lane}</b>',
  'analysis.decision.changed': '<b>{lane}</b> に変更 (AI の推奨: {suggested})',
  'analysis.decision.changedFailSafe': '<b>{lane}</b> に変更 (フェイルセーフの推奨: {suggested})',
  'analysis.decision.change': '変更',
  'analysis.decision.change.aria': '{filename} の決定を変更',
  'analysis.decision.acceptAll': '残りの推奨をすべて承認',
  'analysis.styleGuide.label': 'スタイルガイド',
  'analysis.languagePair.aria': '{source} から {targets} に翻訳',
  'analysis.languagePair.noSource.aria': '{targets} に翻訳',
  'analysis.styleGuide.choose.aria': '{filename} のスタイルガイド: {name}',
  'analysis.styleGuide.popup.aria': 'スタイルガイドを選択',
  'analysis.styleGuide.default': 'デフォルト',
  'analysis.styleGuide.none': 'スタイルガイドなし',
  'analysis.styleGuide.none.description': 'このファイルをスタイルガイドなしで翻訳します。',
  'analysis.styleGuide.search': '名前または言語コードで検索',
  'analysis.styleGuide.search.aria': 'スタイルガイドを検索',
  'analysis.styleGuide.noMatch': '「{query}」に一致するスタイルガイドはありません。',
  'analysis.styleGuide.updated': '更新日: {date}',
  'analysis.styleGuide.help.default': '翻訳開始時点の組織のデフォルトのスタイルガイドに従います。',
  'analysis.styleGuide.help.none': 'このファイルはスタイルガイドなしで翻訳されます。組織のデフォルトは <b>{name}</b> です。',
  'analysis.styleGuide.help.noneNoDefault': 'このファイルはスタイルガイドなしで翻訳されます。',
  'analysis.styleGuide.help.selected': 'デフォルト（<b>{name}</b>）から変更されています。{languages} に適用されます。',
  'analysis.styleGuide.help.selectedNoDefault': 'デフォルト（スタイルガイドなし）から変更されています。{languages} に適用されます。',
  'analysis.styleGuide.help.selectedNoLanguages': 'デフォルト（<b>{name}</b>）から変更されています。',
  'analysis.styleGuide.help.selectedNoDefaultNoLanguages': 'デフォルト（スタイルガイドなし）から変更されています。',
  'analysis.styleGuide.useDefault': 'デフォルトを使用',
  'analysis.styleGuide.loadFailed': 'スタイルガイドを読み込めませんでした。このファイルには組織のデフォルトが使用されます。',
  'analysis.styleGuide.loading': 'スタイルガイドを読み込み中…',
  'analysis.styleGuide.refreshFailed': '一覧を更新できませんでした。選択内容は保持されます。',
  'analysis.xtmCloud.customer.label': 'XTM Cloud の顧客',
  'analysis.xtmCloud.template.label': 'プロジェクトテンプレート',
  'analysis.xtmCloud.customer.choose.aria': '{filename} の XTM Cloud の顧客: {name}',
  'analysis.xtmCloud.template.choose.aria': '{filename} のプロジェクトテンプレート: {name}',
  'analysis.xtmCloud.customer.popup.aria': 'XTM Cloud の顧客を選択',
  'analysis.xtmCloud.template.popup.aria': 'プロジェクトテンプレートを選択',
  'analysis.xtmCloud.search': '名前で検索',
  'analysis.xtmCloud.customer.search.aria': 'XTM Cloud の顧客を検索',
  'analysis.xtmCloud.template.search.aria': 'プロジェクトテンプレートを検索',
  'analysis.xtmCloud.customer.noMatch': '「{query}」に一致する顧客はありません。',
  'analysis.xtmCloud.template.noMatch': '「{query}」に一致するテンプレートはありません。',
  'analysis.xtmCloud.default': 'デフォルト',
  'analysis.xtmCloud.customer.automatic': 'XTM Go（自動作成）',
  'analysis.xtmCloud.customer.unknown': '顧客 {id}',
  'analysis.xtmCloud.template.none': 'テンプレートなし',
  'analysis.xtmCloud.template.global': 'グローバル',
  'analysis.xtmCloud.template.unknown': 'テンプレート {id}',
  'analysis.xtmCloud.help.default': 'ファイルを XTM Cloud に送信する時点の組織のデフォルトの顧客とテンプレートに従います。',
  'analysis.xtmCloud.help.selected': 'デフォルト（<b>{customer}</b>、<b>{template}</b>）から変更されています。',
  'analysis.xtmCloud.help.selectedAutomatic': 'デフォルトから変更されています：<b>XTM Go</b>、自動作成、<b>{template}</b>。',
  'analysis.xtmCloud.useDefault': 'デフォルトを使用',
  'analysis.xtmCloud.loading': '顧客を読み込み中…',
  'analysis.xtmCloud.templates.loading': 'テンプレートを読み込み中…',
  'analysis.xtmCloud.loadFailed': 'XTM Cloud の顧客を読み込めませんでした。このファイルには組織のデフォルトの顧客とテンプレートが使用されます。',
  'analysis.xtmCloud.templates.loadFailed': 'この顧客のテンプレートを読み込めませんでした。',
  'analysis.xtmCloud.refreshFailed': '一覧を更新できませんでした。選択内容は保持されます。',
  'analysis.laneDecision.styleGuideGone': '{filename} に選択したスタイルガイドは存在しなくなりました。別のものを選択してください。',
  'analysis.laneDecision.xtmCustomerGone': '{filename} に選択した XTM Cloud の顧客は利用できなくなりました。別の顧客を選択してください。',
  'analysis.laneDecision.xtmTemplateGone': '{filename} に選択したプロジェクトテンプレートは利用できなくなりました。別のテンプレートを選択してください。',
  'analysis.laneDecision.xtmCloudUnavailable': 'XTM Go は XTM Cloud に接続できず、{filename} に選択した顧客とテンプレートを確認できませんでした。もう一度お試しください。',
  'analysis.announce.accepted': '{filename}: {lane} を承認しました。',
  'analysis.announce.changed': '{filename}: {lane} に変更しました。',
  'analysis.announce.cleared': '{filename}: 決定を取り消しました。',
  'analysis.announce.acceptedAll': '{count} 件のファイルで AI の推奨を承認しました。すべてのファイルが決定済みです。',
  'analysis.announce.decideFirst': '先に残り {count} 件のファイルのレーンを決定してください。',
  'analysis.announce.decideFirstSingle': '先にレーンを承認または変更してください。',
  'analysis.backToUpload': 'アップロードに戻る',
  'analysis.loading.hint': '通常 1 分もかからずに完了します。このタブは開いたままで構いません。自動的に更新されます。',
  'analysis.loading.status.STARTING': '開始しています…',
  'analysis.loading.status.PENDING_UPLOAD': 'ドキュメントを待っています…',
  'analysis.loading.status.UPLOADING': 'ドキュメントをアップロードしています…',
  'analysis.loading.status.PARSING': 'ドキュメントを読み取っています…',
  'analysis.loading.status.READY_FOR_ANALYSIS': '解析の順番を待っています…',
  'analysis.loading.status.ANALYZING': 'ドキュメントのリスクを評価しています…',
  'analysis.loading.status.ANALYZED': '解析を完了しています…',
  'analysis.loading.status.FETCHING_REPORT': '結果をまとめています…',
  'analysis.polling.progress': '{total} 件中 {current} 件目のドキュメント',
  'analysis.error': '分析に失敗しました。もう一度お試しください。',
  'analysis.retry': '再試行',
  'analysis.laneDecision.submitting': 'レーンの決定を送信中...',
  'analysis.laneDecision.error': 'レーンの決定の送信に失敗しました。もう一度お試しください。',
  'analysis.startNew.confirmTitle': 'この翻訳を破棄しますか？',
  'analysis.startNew.confirmBody': 'この翻訳を破棄して新しく開始しますか？アップロードしたファイルはいずれも翻訳されません。',
  'analysis.startNew.confirmButton': '破棄して新規開始',
  'analysis.startNew.cancel': 'キャンセル',
  'analysis.startNew.error': '新しい翻訳を開始できませんでした。もう一度お試しください。',
  'analysis.noData': '分析するドキュメントがありません。前に戻ってファイルをアップロードしてください。',
  'analysis.riskReport.button': 'リスクレポート',
  'analysis.riskReport.veto': '拒否権が発動',
  'analysis.riskReport.failed': '要因が失敗',
  'analysis.riskReport.factor.criticalDownstreamImpactRisk': '重大な下流への影響',
  'analysis.riskReport.factor.structuralFormatIntegrityRisk': '構造・形式の整合性',
  'analysis.riskReport.factor.domainDifficultyClassification': '分野の難易度',
  'analysis.riskReport.factor.referencelessTranslationDifficultyEstimation': '翻訳の難易度',

  // ── Translate Page ───────────────────────────────────────────────────────
  'translate.progress.title': 'コンテンツを翻訳中...',
  'translate.progress.info': '{total} 件中 {current} 件のドキュメントを処理中',
  'translate.progress.hint': '通常は数分で完了します。このタブは開いたままで構いません。自動的に更新されます。',
  'translate.progress.stage.prepare': 'AI エンジン向けにコンテンツを準備しています…',
  'translate.progress.stage.context': '各セグメントの文脈を読み取っています…',
  'translate.progress.stage.translate': 'セグメントごとに翻訳しています…',
  'translate.progress.stage.terminology': '用語とトーンの一貫性を保っています…',
  'translate.progress.stage.quality': '書式と構造を確認しています…',
  'translate.complete.title': '処理が完了しました',
  'translate.complete.filesReady': '{count, plural, one {# 件のファイルが} other {# 件のファイルが}}ダウンロードできます。',
  'translate.complete.inReview': '{count, plural, one {# 件のドキュメントを} other {# 件のドキュメントを}}ヒューマン・イン・ザ・センターのフローで TMS に送信しました。翻訳されたファイルのダウンロード準備ができ次第、メールでお知らせします。',
  'translate.partial.banner.title': '一部のドキュメントに対応が必要です',
  'translate.partial.banner.description': '一部のジョブが失敗しました。失敗したジョブは以下で再試行できます。',
  'translate.table.column.file': 'ドキュメント',
  'translate.table.column.language': '言語',
  'translate.table.column.route': 'レーン',
  'translate.table.column.status': 'ステータス',
  'translate.table.column.action': 'アクション',
  'translate.status.PENDING': '保留中',
  'translate.status.QUEUED': 'キュー待ち',
  'translate.status.PROCESSING': '処理中',
  'translate.status.GENERATING_TARGETS': '翻訳を生成中',
  'translate.status.TRANSLATING': '翻訳中',
  'translate.status.DELIVERING': '配信中',
  'translate.status.IN_PROGRESS': '進行中',
  'translate.status.COMPLETED': '完了',
  'translate.status.FAILED': '失敗',
  'translate.status.inReview': 'ヒューマンレビュー中',
  'translate.status.sent': '送信済み',
  'translate.action.download': 'ダウンロード',
  'translate.action.viewInXtm': 'レビューを表示',
  'translate.action.retry': '再試行',
  'translate.action.downloading': 'ダウンロード中...',
  'translate.action.retrying': '再試行中...',
  'translate.action.retried': '再試行済み',
  'translate.newTranslation': '新しい翻訳を開始',
  'translate.downloadAll': 'すべて ZIP でダウンロード',
  'translate.downloadCompleted': '完了分をダウンロード',
  'translate.loading': '翻訳ジョブを準備中...',
  'translate.error': '翻訳に失敗しました。もう一度お試しください。',
  'translate.noJobs': '翻訳ジョブが見つかりません。前に戻ってレーンの決定を送信してください。',
  'translate.failureReason': '理由: {reason}',
  'translate.retry.error': '再試行に失敗しました。もう一度お試しください。',

  // ── Languages ────────────────────────────────────────────────────────────
  'language.en': '英語',
  'language.fr': 'フランス語',
  'language.de': 'ドイツ語',
  'language.es': 'スペイン語',
  'language.ja': '日本語',
  'language.zh': '中国語（簡体字）',
  'language.pt': 'ポルトガル語',
  'language.it': 'イタリア語',
  'language.ko': '韓国語',
  'language.ar': 'アラビア語',
  'language.nl': 'オランダ語',
  'language.pl': 'ポーランド語',
  'language.sv': 'スウェーデン語',
  'language.el': 'ギリシャ語',

  // ── Shared ───────────────────────────────────────────────────────────────
  'shared.loading': '読み込み中...',
  'shared.error.title': '問題が発生しました',
  'shared.error.description': '予期しないエラーが発生しました。ページを更新してみてください。',
  'shared.error.retry': '再試行',
  'shared.empty': 'データがありません',

  // ── Auth / Admin / Translated files (added in PR #7 merge) ──
  'header.home': 'XTM Go ホーム',
  'header.signOut': 'サインアウト',
  'header.adminXtmCloud': '設定',
  'header.translatedFiles': '翻訳済みファイル',
  'header.help': 'ヘルプとリソース',
  'header.help.documentation': 'ドキュメント',
  'header.help.apiDocumentation': 'API ドキュメント',
  'auth.callback.loading': 'サインインしています…',
  'accessDenied.title': 'アクセスが拒否されました',
  'accessDenied.body': 'サインインは完了しましたが、お使いのアカウントには XTM Go へのアクセス権が付与されていません。誤りと思われる場合は、管理者にお問い合わせください。',
  'admin.xtmCloud.title': '設定',
  'admin.xtmCloud.subtitle': 'XTM Cloud 連携と AI 翻訳設定を管理します。',
  'admin.xtmCloud.status.done': '設定済み',
  'admin.xtmCloud.status.pending': '保留中',
  'admin.xtmCloud.overview.title': 'セットアップの概要',
  'admin.xtmCloud.nav.label': '設定セクション',
  'admin.xtmCloud.nav.unsaved': '未保存の変更があります',
  'admin.xtmCloud.customer.problem.authentication': 'XTM Cloud が保存された認証情報を拒否したため、一覧を読み込めませんでした。上で修正して保存してください。',
  'admin.xtmCloud.customer.problem.unavailable': 'XTM Cloud が応答しなかったため、一覧を読み込めませんでした。保存された認証情報に問題はありません。',
  'admin.xtmCloud.nav.problem': 'XTM Cloud への接続が機能していません',
  'admin.xtmCloud.retry': '再試行',
  'admin.xtmCloud.connector.title': 'LLM コネクター',
  'admin.xtmCloud.footer.unsaved': '未保存の変更',
  'admin.xtmCloud.footer.save': '変更を保存',
  'admin.xtmCloud.footer.discard': '破棄',
  'admin.xtmCloud.loading': '設定を読み込んでいます…',
  'admin.xtmCloud.loadError': 'XTM Cloud の設定を読み込めませんでした。',
  'admin.xtmCloud.connection.title': 'XTM Cloud 接続',
  'admin.xtmCloud.connection.description': 'XTM Go を組織の XTM Cloud アカウントに接続し、ヒューマン・イン・ザ・センターに送るファイルのデフォルトの顧客とプロジェクトテンプレートを選択します。ベース URL は組織の SSO 設定から取得され、ここでは変更できません。',
  'admin.xtmCloud.baseUrl': 'ベース URL',
  'admin.xtmCloud.client': 'クライアント',
  'admin.xtmCloud.username': 'ユーザー名',
  'admin.xtmCloud.password': 'パスワード',
  'admin.xtmCloud.passwordSet': 'パスワード設定済み',
  'admin.xtmCloud.passwordNotSet': 'パスワード未設定',
  'admin.xtmCloud.saved': '変更を保存しました。',
  'admin.xtmCloud.credentialsError': '認証情報を保存できませんでした。',
  'admin.xtmCloud.credentialsIncomplete': '認証情報を保存するには、クライアント、ユーザー名、パスワードのすべてが必要です。',
  'admin.xtmCloud.customer.locked': '顧客を読み込むには、先に認証情報を保存してください。',
  'admin.xtmCloud.customer.label': 'デフォルトの顧客',
  'admin.xtmCloud.customer.select': '顧客を選択',
  'admin.xtmCloud.customer.loading': '顧客を読み込んでいます…',
  'admin.xtmCloud.customer.unavailable': 'この顧客は XTM Cloud で有効ではなくなりました。別の顧客を選択してください。',
  'admin.xtmCloud.customerError': '選択した顧客を保存できませんでした。',
  'admin.xtmCloud.template.select': 'デフォルトのプロジェクトテンプレート',
  'admin.xtmCloud.template.none': 'テンプレートなし',
  'admin.xtmCloud.template.global': 'グローバル',
  'admin.xtmCloud.template.locked': 'プロジェクトテンプレートを選択するには、先に顧客を選択してください。',
  'admin.xtmCloud.template.loadFailed': 'プロジェクトテンプレートを読み込めませんでした。',
  'admin.xtmCloud.template.unavailable': 'このテンプレートは XTM Cloud に存在しなくなりました。別のテンプレートを選択してください。',
  'admin.xtmCloud.templateError': 'プロジェクトテンプレートを保存できませんでした。',
  'admin.xtmCloud.problem.authentication.title': 'XTM Cloud が保存された認証情報を拒否しました',
  'admin.xtmCloud.problem.authentication.body': '下のクライアントとユーザー名を確認し、パスワードを再入力して保存してください。XTM Cloud は保存済みのパスワードを返さないため、確認はできず、置き換えるしかありません。',
  'admin.xtmCloud.problem.unavailable.title': 'XTM Cloud が応答していません',
  'admin.xtmCloud.problem.unavailable.body': '一時的な状態で、保存された認証情報に問題はありません。少し待ってから再試行してください。パスワードを変更する必要はありません。',
  'admin.xtmCloud.problem.reference': '参照 ID: {id}',
  'admin.xtmCloud.none': '—',
  'admin.xtmCloud.llm.description': '翻訳に使用する AI コネクタを選択します。',
  'admin.xtmCloud.llm.riskAssessmentOverride': 'このコネクタは AI リスク評価にも使用され、そちらで設定されている既定のコネクタを上書きします。',
  'admin.xtmCloud.tools.riskAssessment': 'リスク評価',
  'admin.xtmCloud.tools.mtLlmGateway': 'XTM Gateway',
  'admin.xtmCloud.tools.newTab': '(新しいタブで開きます)',
  'admin.xtmCloud.llm.select': 'コネクタを選択',
  'admin.xtmCloud.llm.saved': '設定を保存しました。',
  'admin.xtmCloud.llm.error': '設定を保存できませんでした。',
  'admin.xtmCloud.llm.loadError': 'コネクタを読み込めませんでした。',
  'admin.xtmCloud.llm.loading': 'コネクタを読み込んでいます…',
  'admin.xtmCloud.llm.unavailable': '利用できないコネクタ',
  'admin.xtmCloud.llm.missing': '保存されたコネクタは利用できなくなりました。無効化または削除された可能性があります。別のコネクタを選択してください。',
  'admin.xtmCloud.llm.nav.problem': '保存された LLM コネクタは利用できなくなりました',
'admin.xtmCloud.llm.translationMode': 'Translation mode',  'admin.xtmCloud.llm.mode.single': 'Single',  'admin.xtmCloud.llm.mode.batch': 'Batch',  'admin.xtmCloud.llm.batchSize': 'Batch size',  'admin.xtmCloud.llm.batchSize.hint': '1 バッチあたり 1〜50 ドキュメント',
  'translatedBatches.title': '翻訳済みファイル',
  'translatedBatches.searchPlaceholder': 'ファイル名で検索…',
  'translatedBatches.loading': 'バッチを読み込んでいます…',
  'translatedBatches.error': '翻訳済みバッチを読み込めませんでした。',
  'translatedBatches.empty': 'バッチが見つかりませんでした。',
  'translatedBatches.downloadAll': 'すべてダウンロード',
  'translatedBatches.openInXtm': 'XTM Cloud で開く',
  'translatedBatches.filesLoading': 'ファイルを読み込んでいます…',
  'translatedBatches.filesError': 'このバッチのファイルを読み込めませんでした。',
  'translatedBatches.noFiles': 'このバッチには翻訳済みファイルがありません。',
  'translatedBatches.prev': '前へ',
  'translatedBatches.next': '次へ',
  'translatedBatches.pageOf': '{total} ページ中 {current} ページ',
  'translatedBatches.count': '{count, plural, other {# 件のバッチ}}',
  'translatedBatches.fileCount': '{count, plural, other {# 件のファイル}}',
  'translatedBatches.fileMeta': '{language} · {source} から',
  'translatedBatches.moreLanguages': '+{count}',
  'translatedBatches.expand': '翻訳済みファイルを表示',
  'translatedBatches.collapse': '翻訳済みファイルを非表示',
  'translatedBatches.download': 'ダウンロード',
  'translatedBatches.downloading': 'ダウンロード中…',
  'translatedBatches.downloadFile': '{filename} をダウンロード',
  'translatedBatches.zipping': 'ZIP を準備しています…',
  'translatedBatches.status.inProgress': '処理中',
  'translatedBatches.status.failed': '失敗',
  'translatedBatches.status.expired': '期限切れ',
  'translatedBatches.moreFiles': '+{count}',
  'translatedBatches.readyOf': '{total} 件中 {ready} 件が完了',
  'translatedBatches.state.translating': '翻訳中',
  'translatedBatches.state.inXtmCloud': '翻訳者が対応中',
  'translatedBatches.state.inXtmCloud.tooltip': 'XTM Cloud の翻訳者がこのファイルを翻訳しています。数日かかる場合があります。完了するとメールでお知らせします。',
  'translatedBatches.state.unavailable': 'XTM Cloud のみ',
  'translatedBatches.state.unavailable.tooltip': '翻訳は完了しましたが、ファイルを XTM Go に取得できませんでした。XTM Cloud のプロジェクトを開いて受け取ってください。',
  'translatedBatches.state.failed': '失敗',
  'translatedBatches.noResults': '「{query}」に一致するものがありません。',
  'translatedBatches.noResultsHint': '別のファイル名でお試しください。',
  'translatedBatches.emptyHint': '翻訳したファイルがここに表示されます。',
  'translatedBatches.clearSearch': '検索をクリア',
  'translatedBatches.pagination': 'ページ送り',
  'translatedBatches.single.title': '翻訳済みバッチ',
  'translatedBatches.single.backToAll': 'すべての翻訳済みファイル',
  'translatedBatches.single.notFound': 'このバッチは存在しないか、閲覧する権限がありません。',
  'translatedBatches.single.notFoundHint': 'リンクを確認するか、すべての翻訳済みファイルを開いてください。',
  'translatedBatches.single.error': 'このバッチを読み込めませんでした。',
  'admin.styleGuides.title': 'スタイルガイド',
  'admin.styleGuides.nav.problem': 'デフォルトのスタイルガイドは存在しなくなりました',
  'admin.styleGuides.description': 'XTM Go はスタイルガイドを XTM Cloud およびその他の XTM 製品と共有しているため、ここで行った編集や削除はすべての場所に反映されます。ただし、以下で選択するデフォルトは、XTM Go 内の AI-Direct レーンにのみ適用されます。',
  'admin.styleGuides.summary.using': 'AI-Direct 翻訳では、デフォルトで {name} が使用されます。',
  'admin.styleGuides.summary.none': 'デフォルトのスタイルガイドはありません。AI-Direct 翻訳はスタイルガイドなしで実行されます。',
  'admin.styleGuides.create': '新しいスタイルガイド',
  'admin.styleGuides.edit': '{name} を編集',
  'admin.styleGuides.delete': '{name} を削除',
  'admin.styleGuides.action.edit': '編集',
  'admin.styleGuides.action.delete': '削除',
  'admin.styleGuides.action.useNoDefault': 'スタイルガイドなしにする',
  'admin.styleGuides.delete.title': '{name} を削除しますか？',
  'admin.styleGuides.delete.body': '{name} を、すべてのユーザーに対して、XTM Cloud を含む使用されているすべての場所から完全に削除します。',
  'admin.styleGuides.delete.bodySelected': '{name} を、すべてのユーザーに対して、XTM Cloud を含む使用されているすべての場所から完全に削除します。デフォルトのスタイルガイドのため、別のデフォルトまたは「スタイルガイドなし」を選択するまで AI-Direct 翻訳は失敗します。',
  'admin.styleGuides.delete.confirm': '削除',
  'admin.styleGuides.delete.cancel': 'キャンセル',
  'admin.styleGuides.delete.error': '{name} を削除できませんでした。何も変更されていません。',
  'admin.styleGuides.delete.busy': '現在 {name} を削除できません。しばらくしてからもう一度お試しください。',
  'admin.styleGuides.loadError': 'スタイルガイドを読み取れませんでした。読み取りの問題であり、スタイルガイドが無いという意味ではありません。既定のスタイルガイドは変更されていません。',
  'admin.styleGuides.retry': '再試行',
  'admin.styleGuides.loadFailedUseNone.hint': 'スタイルガイドを読み込めない間は、デフォルトのスタイルガイドを解除して、AI-Direct 翻訳を再び動作させることができます。',
  'admin.styleGuides.loadFailedUseNone.done': '現在、デフォルトのスタイルガイドはありません。AI-Direct 翻訳はスタイルガイドなしで実行されます。',
  'admin.styleGuides.noLanguages': '言語セクションなし',
  'admin.styleGuides.saveError': '保存できませんでした。デフォルトは引き続き {previous} です。',
  'admin.styleGuides.saveErrorUnchanged': '保存できませんでした。デフォルトのスタイルガイドは変更されていません。',
  'admin.styleGuides.noDefault': 'スタイルガイドなし',
  'admin.styleGuides.noDefault.description': 'AI-Direct 翻訳はスタイルガイドなしで実行されます。',
  'admin.styleGuides.notUsedByXtmGo': 'XTM Go では使用されません',
  'admin.styleGuides.warning.missing': '{name} はデフォルトでしたが、存在しなくなりました（{date} に検出）。別のデフォルトまたは「スタイルガイドなし」を選択するまで、AI-Direct 翻訳は失敗します。',
  'admin.styleGuides.column.name': '名前',
  'admin.styleGuides.column.languages': '言語',
  'admin.styleGuides.column.updated': '更新日',
  'admin.styleGuides.column.default': 'デフォルト',
  'admin.styleGuides.column.actions': '操作',
  'admin.styleGuides.default.checked': 'デフォルト',
  'admin.styleGuides.default.unchecked': 'デフォルトに設定',
  'admin.styleGuides.default.noneSr': 'スタイルガイドなし',
  'admin.styleGuides.editor.loading': 'スタイルガイドエディターを開いています…',
  'admin.styleGuides.editor.loadError': 'スタイルガイドエディターを読み込めませんでした。スタイルガイドは変更されていません。',
  'admin.styleGuides.editor.back': 'スタイルガイドに戻る',
  'admin.styleGuides.editor.authOrganization': 'スタイルガイド用の組織 ID が設定されていません。XTM Cloud 接続設定で XTM Cloud クライアントを設定してください。',
  'admin.styleGuides.editor.authForbidden': 'スタイルガイドを編集する権限がなくなりました。',
  'admin.styleGuides.editor.authFailed': '編集セッションが終了しました。続けるにはエディターを開き直してください。保存していない変更は、ページを離れるまで保持されます。',
  'admin.styleGuides.editor.unavailable': 'このスタイルガイドは利用できません。',
  'admin.styleGuides.editor.navigationNote': 'セクションを切り替えたり前に戻ったりすると、保存していない変更は失われます。エディターの「キャンセル」または「保存」を使用してください。',

  // ── Language issues (COPA-877, COPA-878): draft, needs translation review ──
  'languageIssue.FILE_NOT_CREATED': '{language}: 翻訳済みファイルを作成できませんでした。',
  'languageIssue.FILE_NOT_CREATED_IN_TIME': '{language}: 翻訳済みファイルを時間内に作成できませんでした。',
  'languageIssue.TOO_MUCH_UNTRANSLATED': '{language}: 翻訳できなかったテキストが多すぎます。',
  'languageIssue.CONNECTOR_STALLED': '{language}: AI-Direct レーンで LLM コネクターが応答しなくなりました。',
  'languageIssue.CONNECTOR_UNAVAILABLE': '{language}: AI-Direct レーンから LLM コネクターに接続できませんでした。',
  'languageIssue.STYLE_GUIDE_UNAVAILABLE': '{language}: 組織のスタイルガイドを読み込めませんでした。もう一度お試しいただくか、ファイルを XTM Cloud に送信してください。',
  'languageIssue.STYLE_GUIDE_DELETED': '{language}: 組織のスタイルガイドが削除されました。管理者に別のオプションを選択するよう依頼するか、ファイルを XTM Cloud に送信してください。',
  'languageIssue.STYLE_GUIDE_NOT_CONFIGURED': '{language}: 接続が設定されていないため、XTM Go は組織のスタイルガイドにアクセスできませんでした。管理者に XTM Cloud 接続の確認を依頼するか、ファイルを XTM Cloud に送信してください。',
  'languageIssue.STYLE_GUIDE_FILE_UNAVAILABLE': '{language}: このファイルに選択したスタイルガイドを読み込めませんでした。もう一度お試しいただくか、ファイルを XTM Cloud に送信してください。',
  'languageIssue.STYLE_GUIDE_FILE_DELETED': '{language}: このファイルに選択したスタイルガイドは削除されました。ファイルを再度アップロードするか、XTM Cloud に送信してください。',
  'languageIssue.DELIVERED_WITH_UNTRANSLATED': '{language}: LLM コネクターが応答しなくなったため、{untranslatedSegments, plural, one {# 個のセグメント} other {# 個のセグメント}}がソース言語のまま納品されました。',
  'languageIssue.STOPPED_UNEXPECTEDLY': '{language}: 翻訳が予期せず停止しました。もう一度お試しください。',
  'languageIssue.CONNECTOR_NOT_CONFIGURED': '{language}: 組織に LLM コネクターが設定されていません。管理者に設定を依頼するか、ファイルを XTM Cloud に送信してください。',
  'languageIssue.UNSUPPORTED_STRUCTURE': '{language}: このファイルの構造はサポートされていません。ファイルを XTM Cloud に送信してください。',
  'languageIssue.SOURCE_FILE_MISSING': '{language}: 翻訳に必要なファイルが利用できなくなりました。ファイルを再アップロードしてください。',
  'languageIssue.PARSED_DOCUMENT_UNREADABLE': '{language}: 翻訳済みファイルを作成できませんでした。ファイルを再アップロードしてください。',
  'languageIssue.UPLOADED_BEFORE_UPDATE': '{language}: ファイルを再アップロードしてください。このファイルはアップデート前にアップロードされました。',
  'languageIssue.SOURCE_LANGUAGE_NO_CONNECTOR': '{language}: LLM コネクターが設定されていないため、ソース言語を検出できませんでした。管理者に設定を依頼してください。',
  'languageIssue.SOURCE_LANGUAGE_CONNECTOR_FAILED': '{language}: LLM コネクターが応答しなかったため、ソース言語を検出できませんでした。もう一度お試しください。',
  'languageIssue.XTM_CLOUD_CONNECTION': '{language}: XTM Go は XTM Cloud に接続できませんでした。管理者に XTM Cloud 接続の確認を依頼してください。',
  'languageIssue.XTM_CLOUD_UNSUPPORTED_FORMAT': '{language}: XTM Cloud はこのファイル形式をサポートしていません。',
  'languageIssue.XTM_CLOUD_PASSWORD_PROTECTED': '{language}: XTM Cloud がファイルを拒否しました。パスワードで保護されている可能性があります。',
  'languageIssue.XTM_CLOUD_FILE_TOO_LARGE': '{language}: ファイルが XTM Cloud で受け付けられるサイズを超えています (上限: {limit})。',
  'languageIssue.XTM_CLOUD_FILE_TOO_LARGE_NO_LIMIT': '{language}: ファイルが XTM Cloud で受け付けられるサイズを超えています。',
  'languageIssue.XTM_CLOUD_PROJECT_REFUSED': '{language}: XTM Cloud がプロジェクトを拒否しました。もう一度お試しください。',
  'languageIssue.XTM_CLOUD_PROJECT_MAY_EXIST': '{language}: XTM Cloud プロジェクト (「{projectName}」) が既に存在する可能性があります。再試行する前に XTM Cloud を確認してください。',
  'languageIssue.XTM_CLOUD_HANDOVER_FAILED': '{language}: ファイルを XTM Cloud に送信できませんでした。もう一度お試しください。',
  'languageIssue.XTM_CLOUD_TARGET_NOT_RETRIEVED': '{language}: 翻訳済みファイルを XTM Cloud から取得できませんでした。',
  'languageIssue.XTM_CLOUD_CUSTOMER_UNAVAILABLE': '{language}: このファイルに選択した XTM Cloud の顧客は利用できなくなりました。別の顧客でファイルを再度決定するか、AI-Direct に送信してください。',
  'languageIssue.XTM_CLOUD_TEMPLATE_UNAVAILABLE': '{language}: このファイルに選択したプロジェクトテンプレートは XTM Cloud で利用できなくなりました。別のテンプレートでファイルを再度決定するか、AI-Direct に送信してください。',
  'languageIssue.XTM_CLOUD_DEFAULT_CUSTOMER_UNAVAILABLE': '{language}: 組織の XTM Cloud の顧客は利用できなくなりました。管理者に別の顧客を選択するよう依頼するか、ファイルを AI-Direct に送信してください。',
  'languageIssue.XTM_CLOUD_DEFAULT_TEMPLATE_UNAVAILABLE': '{language}: 組織のプロジェクトテンプレートは XTM Cloud で利用できなくなりました。管理者に別のテンプレートを選択するよう依頼するか、ファイルを AI-Direct に送信してください。',
  'languageIssue.UNKNOWN_FAILURE': '{language}: 翻訳が予期せず停止しました。もう一度お試しください。',
  'languageIssue.UNKNOWN_WARNING': '{language}: 警告付きで納品されました。',
  'languageIssue.reference': '参照番号: {uploadBatchId}',
  'languageIssue.copyReference': '参照番号をコピー',
};

export default ja;
